/* svg全局注册 */
import Vue from "vue";
import RbdSvgIcon from "./RbdSvgIcon.vue";

//注册到全局
Vue.component("rbd-svg-icon", RbdSvgIcon);
const req = require.context("./icons", false, /\.svg$/);
const funcRequireAll = (rc) => rc.keys().map(rc);
funcRequireAll(req);
